import React, { useState } from 'react';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import ArrowIcon from '../../../../images/arrow.png';

const SortBar = ({ checked, handleCheck }) => {
  const [isOpened, setIsOpened] = useState(false);
  const open = () => {
    setIsOpened(!isOpened);
  };
  return (
    <SortWrapper>
      <FilterTitle onClick={open}>
        Cортировать блюда
        <Img src={ArrowIcon} alt="arrow" isOpened={isOpened} />
      </FilterTitle>
      <Collapse isOpened={isOpened}>
        <SortBoxes>
          <SortParamWrapper>
            <SortParam>По дате добавления</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="id1"
                order="desc"
                checked={checked === 'id1'}
                onChange={(event) => handleCheck(event)}
              />
              От новых к старым
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="id2"
                order="asc"
                checked={checked === 'id2'}
                onChange={(event) => handleCheck(event)}
              />
              От старых к новым
            </Label>
          </SortParamWrapper>
          <SortParamWrapper>
            <SortParam>По имени</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="name1"
                order="asc"
                checked={checked === 'name1'}
                onChange={(event) => handleCheck(event)}
              />
              От А до Я
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="name2"
                order="desc"
                checked={checked === 'name2'}
                onChange={(event) => handleCheck(event)}
              />
              От Я до А
            </Label>
          </SortParamWrapper>
          <SortParamWrapper>
            <SortParam>Калории</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="calories1"
                order="desc"
                checked={checked === 'calories1'}
                onChange={(event) => handleCheck(event)}
              />
              По убыванию
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="calories2"
                order="asc"
                checked={checked === 'calories2'}
                onChange={(event) => handleCheck(event)}
              />
              По возрастанию
            </Label>
          </SortParamWrapper>
          <SortParamWrapper>
            <SortParam>Белки</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="proteins1"
                order="desc"
                checked={checked === 'proteins1'}
                onChange={(event) => handleCheck(event)}
              />
              По убыванию
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="proteins2"
                order="asc"
                checked={checked === 'proteins2'}
                onChange={(event) => handleCheck(event)}
              />
              По возрастанию
            </Label>
          </SortParamWrapper>
          <SortParamWrapper>
            <SortParam>Жиры</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="fats1"
                order="desc"
                checked={checked === 'fats1'}
                onChange={(event) => handleCheck(event)}
              />
              По убыванию
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="fats2"
                order="asc"
                checked={checked === 'fats2'}
                onChange={(event) => handleCheck(event)}
              />
              По возрастанию
            </Label>
          </SortParamWrapper>
          <SortParamWrapper>
            <SortParam>Углеводы</SortParam>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="carbohydrates1"
                order="desc"
                checked={checked === 'carbohydrates1'}
                onChange={(event) => handleCheck(event)}
              />
              По убыванию
            </Label>
            <Label>
              <Check
                type="radio"
                name="sort"
                value="carbohydrates2"
                order="asc"
                checked={checked === 'carbohydrates2'}
                onChange={(event) => handleCheck(event)}
              />
              По возрастанию
            </Label>
          </SortParamWrapper>
        </SortBoxes>
      </Collapse>
    </SortWrapper>
  );
};

export default SortBar;

const SortWrapper = styled.div`
  width: 95%;
  margin: 0 auto;
`;

const FilterTitle = styled.h3`
  margin: 10px 0;
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 40px;
  cursor: pointer;
  background: #157aac;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;

const Img = styled.img`
  margin-left: 25px;
  width: 15px;
  height: 15px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : '')};
`;

const SortBoxes = styled.div`
  display: flex;
  flex-flow: row wrap;
  position: relative;
  padding: 15px 0 0;
  width: 100%;
  box-sizing: border-box;
`;

const SortParamWrapper = styled.div`
  width: 25%;
  min-width: 230px;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  flex-flow: column nowrap;
`;

const SortParam = styled.p`
  width: 100%;
  font-size: 20px;
  margin-bottom: 10px;
`;

const Label = styled.label`
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 5px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const Check = styled.input`
  margin-right: 5px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/FilterBar/SortBar/SortBar.jsx